module.exports = __webpack_public_path__ + "assets/img/corona.001eae75.jpg";